<template>
  <div
    :class="
      `bs-wrapper sh-button ${
        disabled ? 'disabled' : type
      } flex-col ${size}-size`
    "
    @click="disabled || $emit('click')"
  >
    <span>
      <component
        v-bind:is="loading ? 'loading' : 'span'"
        type="spinner"
        size="24px"
      >
        <slot />
      </component>
    </span>
  </div>
</template>

<script>
import 'vant/lib/loading/style';

export default {
  name: 'SHButton',

  mixins: [],

  components: {
    Loading: () => import('vant/lib/loading'),
  },

  props: {
    /**
     * default 默认 （白底红字）
     * primary 常规 （红底白字）
     * disabled 禁用置灰
     * confirmed 已确认 （置灰红底白字）
     */
    type: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
      default: 'medium', // medium 中等 large 超长
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.sh-button {
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 44px;
  border-radius: 22px;
  border-width: 1px;
  user-select: none;
  span {
    font-size: 16px;
  }
  &.default {
    border: 1px solid #FF6F00;
    box-shadow: 0 3px 12px 1px rgba(228, 19, 53, 0.35);
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0);
    span {
      color: #FF6F00;
    }
  }
  &.primary {
    width: 200px;
    height: 44px;
    background: #FF6F00;
    box-shadow: 0 3px 12px 1px rgba(228, 19, 53, 0.35);
    border-radius: 22px;
    span {
      color: rgba(255, 255, 255, 1);
    }
  }
  &.disabled {
    background: linear-gradient(90deg, #dbdcdd 0%, #f0f0f0 100%);
    span {
      color: rgba(255, 255, 255, 1);
    }
  }
  &.confirmed {
    background: linear-gradient(90deg, #febabb 0%, #ffd7d9 100%);
    span {
      color: rgba(255, 255, 255, 1);
    }
  }
  &.medium-size {
    width: 164px;
  }
  &.large-size {
    width: 100%;
  }
}
</style>
